import { proxy, ref } from "valtio"
import { deepClone } from "valtio/utils"
import type { OnConnectedCallback } from "../polychain/hooks"

// -- Types ---------------------------------------------------------
type ConnectStateType = {
  onConnectedCallbacks: OnConnectedCallback[]
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: ConnectStateType = {
  onConnectedCallbacks: [],
}

export const ConnectState = proxy<ConnectStateType>(deepClone(INITIAL_STATE))

// -- Actions -------------------------------------------------------
export const ConnectActions = {
  addOnConnectedCallback(callback: OnConnectedCallback) {
    ConnectState.onConnectedCallbacks.push(ref(callback))
  },

  removeOnConnectedCallback(callback: OnConnectedCallback) {
    ConnectState.onConnectedCallbacks =
      ConnectState.onConnectedCallbacks.filter(cb => cb !== callback)
  },
}
